import { defineField, Validators } from '@/form/useForm'
import type { UseAssetFormComputedData, UseAssetFormState } from '../types'

export const ownershipPercentageField = () => {
  return defineField<UseAssetFormState, number, UseAssetFormComputedData>({
    type: 'number',
    label: 'I Own',
    value: 100,
    placeholder: '0',
    display: { value: '%' },
    validators: [Validators.range(0, 100)],
  })
}
